import React from "react";
import { Header, Container, Grid, Image, Responsive } from "semantic-ui-react";
import {
  estacionamientoIcon,
  recamarasIcon,
  precioIcon,
  vestidorIcon,
  construccionIcon,
  banoIcon
} from "../../assets/Assets";

const formatter = new Intl.NumberFormat("es-MX", {
  style: "currency",
  currency: "MXN",
  minimumFractionDigits: 2
  // the default value for minimumFractionDigits depends on the currency
  // and is usually already 2
});

class PropiedadesPage extends React.Component {
  constructor(props) {
    super(props);
  }

  renderInDesktop() {
    let constructArea = "";
    if (this.props.specsData.constructArea !== undefined) {
      constructArea =
        this.props.specsData.constructArea.width +
        " m²" +
        " - " +
        this.props.specsData.constructArea.height +
        " m²";
    }

    return (
      <div>
        <div
          style={{
            backgroundColor: "#023552",
            width: "100%",
            padding: "60px 60px"
          }}
        >
          <Grid columns={2}>
            <Grid.Column>
              <div
                style={{
                  display: "flex"
                }}
              >
                <div>
                  <Image
                    src={precioIcon}
                    style={{
                      height: "48px",
                      width: "48px"
                    }}
                  />
                </div>
                <div
                  style={{
                    marginLeft: "40px"
                  }}
                >
                  <Header
                    style={{
                      color: "#fff",
                      padding: "0px",
                      margin: "0px"
                    }}
                  >
                    {formatter.format(this.props.specsData.minPrice).toString()}{" "}
                    -{" "}
                    {formatter.format(this.props.specsData.maxPrice).toString()}
                  </Header>
                  <p
                    style={{
                      fontFamily: "Lato",
                      fontWeight: 300,
                      color: "#fff"
                    }}
                  >
                    PRECIO DESDE:
                  </p>
                </div>
              </div>
            </Grid.Column>

            <Grid.Column textAlign="left">
              <div
                style={{
                  display: "flex"
                }}
              >
                <div>
                  <Image
                    src={construccionIcon}
                    style={{
                      height: "48px",
                      width: "48px"
                    }}
                  />
                </div>
                <div
                  style={{
                    marginLeft: "40px"
                  }}
                >
                  <Header
                    style={{
                      color: "#fff",
                      padding: "0px",
                      margin: "0px"
                    }}
                  >
                    {constructArea}
                  </Header>
                  <p
                    style={{
                      fontFamily: "Lato",
                      fontWeight: 300,
                      color: "#fff"
                    }}
                  >
                    ÁREA DE CONSTRUCCIÓN:
                  </p>
                </div>
              </div>
            </Grid.Column>
          </Grid>

          <Grid columns={4}>
            <Grid.Column>
              <Grid>
                <Grid.Column>
                  <div
                    style={{
                      display: "flex"
                    }}
                  >
                    <div>
                      <Image
                        src={recamarasIcon}
                        style={{
                          height: "48px",
                          width: "48px",
                          verticalAlign: "top"
                        }}
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginLeft: "40px"
                      }}
                    >
                      <div>
                        <Header
                          style={{
                            color: "#fff",
                            padding: "0px",
                            margin: "0px"
                          }}
                        >
                          {this.props.specsData.rooms}
                        </Header>
                      </div>

                      <div>
                        <p
                          style={{
                            fontFamily: "Lato",
                            fontWeight: 300,
                            color: "#fff"
                          }}
                        >
                          RECÁMARAS:
                        </p>
                      </div>
                    </div>
                  </div>
                </Grid.Column>
              </Grid>
            </Grid.Column>
            <Grid.Column>
              <div
                style={{
                  display: "flex"
                }}
              >
                <div>
                  <Image
                    src={banoIcon}
                    style={{
                      height: "48px",
                      width: "48px",
                      verticalAlign: "top"
                    }}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginLeft: "40px"
                  }}
                >
                  <div>
                    <Header
                      style={{
                        color: "#fff",
                        padding: "0px",
                        margin: "0px"
                      }}
                    >
                      {this.props.specsData.bathrooms}
                    </Header>
                  </div>

                  <div>
                    <p
                      style={{
                        fontFamily: "Lato",
                        fontWeight: 300,
                        color: "#fff"
                      }}
                    >
                      BAÑOS:
                    </p>
                  </div>
                </div>
              </div>
            </Grid.Column>
            <Grid.Column>
              <div
                style={{
                  display: "flex"
                }}
              >
                <div>
                  <Image
                    src={estacionamientoIcon}
                    style={{
                      height: "48px",
                      width: "48px",
                      verticalAlign: "top"
                    }}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginLeft: "40px"
                  }}
                >
                  <div>
                    <Header
                      style={{
                        color: "#fff",
                        padding: "0px",
                        margin: "0px"
                      }}
                    >
                      {this.props.specsData.parkinglots}
                    </Header>
                  </div>

                  <div>
                    <p
                      style={{
                        fontFamily: "Lato",
                        fontWeight: 300,
                        color: "#fff"
                      }}
                    >
                      ESTACIONAMIENTO:
                    </p>
                  </div>
                </div>
              </div>
            </Grid.Column>
            {this.props.specsData.dressrooms !== 0 ? (
              <Grid.Column>
                <div
                  style={{
                    display: "flex"
                  }}
                >
                  <div>
                    <Image
                      src={vestidorIcon}
                      style={{
                        height: "48px",
                        width: "48px",
                        verticalAlign: "top"
                      }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginLeft: "40px"
                    }}
                  >
                    <div>
                      <Header
                        style={{
                          color: "#fff",
                          padding: "0px",
                          margin: "0px"
                        }}
                      >
                        {this.props.specsData.dressrooms}
                      </Header>
                    </div>
                    <div>
                      <p
                        style={{
                          fontFamily: "Lato",
                          fontWeight: 300,
                          color: "#fff"
                        }}
                      >
                        VESTIDOR:
                      </p>
                    </div>
                  </div>
                </div>
              </Grid.Column>
            ) : (
              ""
            )}
          </Grid>
        </div>
      </div>
    );
  }

  renderInTablet() {
    let constructArea = "";
    if (this.props.specsData.constructArea !== undefined) {
      constructArea =
        this.props.specsData.constructArea.width +
        " m²" +
        " - " +
        this.props.specsData.constructArea.height +
        " m²";
    }
    return (
      <div>
        <div
          style={{
            backgroundColor: "#023552",
            width: "100%",
            padding: "25px"
          }}
        >
          <Grid columns={2}>
            <Grid.Column>
              <div
                style={{
                  display: "flex"
                }}
              >
                <div>
                  <Image
                    src={precioIcon}
                    style={{
                      height: "38px",
                      width: "38px"
                    }}
                  />
                </div>
                <div
                  style={{
                    marginLeft: "10px"
                  }}
                >
                  <Header
                    style={{
                      color: "#fff",
                      padding: "0px",
                      margin: "0px",
                      fontSize: "1.2rem"
                    }}
                  >
                    {formatter.format(this.props.specsData.minPrice).toString()}{" "}
                    -{" "}
                    {formatter.format(this.props.specsData.maxPrice).toString()}
                  </Header>
                  <p
                    style={{
                      fontSize: "0.7rem",
                      fontFamily: "Lato",
                      fontWeight: 300,
                      color: "#fff"
                    }}
                  >
                    PRECIO DESDE:
                  </p>
                </div>
              </div>
            </Grid.Column>

            <Grid.Column textAlign="left">
              <div
                style={{
                  display: "flex"
                }}
              >
                <div>
                  <Image
                    src={construccionIcon}
                    style={{
                      height: "38px",
                      width: "38px"
                    }}
                  />
                </div>
                <div
                  style={{
                    marginLeft: "10px"
                  }}
                >
                  <Header
                    style={{
                      color: "#fff",
                      padding: "0px",
                      margin: "0px",
                      fontSize: "1.2rem"
                    }}
                  >
                    {constructArea}
                  </Header>
                  <p
                    style={{
                      fontFamily: "Lato",
                      fontWeight: 300,
                      color: "#fff",
                      fontSize: "0.7rem"
                    }}
                  >
                    ÁREA DE CONSTRUCCIÓN:
                  </p>
                </div>
              </div>
            </Grid.Column>
          </Grid>

          <Grid columns={2}>
            <Grid.Column>
              <Grid>
                <Grid.Column>
                  <div
                    style={{
                      display: "flex"
                    }}
                  >
                    <div>
                      <Image
                        src={recamarasIcon}
                        style={{
                          height: "38px",
                          width: "38px",
                          verticalAlign: "top"
                        }}
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginLeft: "10px"
                      }}
                    >
                      <div>
                        <Header
                          style={{
                            color: "#fff",
                            padding: "0px",
                            margin: "0px",
                            fontSize: "1.2rem"
                          }}
                        >
                          {this.props.specsData.rooms}
                        </Header>
                      </div>

                      <div>
                        <p
                          style={{
                            fontFamily: "Lato",
                            fontWeight: 300,
                            color: "#fff",
                            fontSize: "0.7rem"
                          }}
                        >
                          RECÁMARAS:
                        </p>
                      </div>
                    </div>
                  </div>
                </Grid.Column>
              </Grid>
            </Grid.Column>
            <Grid.Column>
              <div
                style={{
                  display: "flex"
                }}
              >
                <div>
                  <Image
                    src={banoIcon}
                    style={{
                      height: "38px",
                      width: "38px",
                      verticalAlign: "top"
                    }}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginLeft: "10px"
                  }}
                >
                  <div>
                    <Header
                      style={{
                        color: "#fff",
                        padding: "0px",
                        margin: "0px",
                        fontSize: "1.2rem"
                      }}
                    >
                      {this.props.specsData.bathrooms}
                    </Header>
                  </div>

                  <div>
                    <p
                      style={{
                        fontFamily: "Lato",
                        fontWeight: 300,
                        color: "#fff",
                        fontSize: "0.7rem"
                      }}
                    >
                      BAÑOS:
                    </p>
                  </div>
                </div>
              </div>
            </Grid.Column>
            <Grid.Column>
              <div
                style={{
                  display: "flex"
                }}
              >
                <div>
                  <Image
                    src={estacionamientoIcon}
                    style={{
                      height: "38px",
                      width: "38px",
                      verticalAlign: "top"
                    }}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginLeft: "10px"
                  }}
                >
                  <div>
                    <Header
                      style={{
                        color: "#fff",
                        padding: "0px",
                        margin: "0px",
                        fontSize: "1.2rem"
                      }}
                    >
                      {this.props.specsData.parkinglots}
                    </Header>
                  </div>

                  <div>
                    <p
                      style={{
                        fontFamily: "Lato",
                        fontWeight: 300,
                        color: "#fff",
                        fontSize: "0.7rem"
                      }}
                    >
                      ESTACIONAMIENTO:
                    </p>
                  </div>
                </div>
              </div>
            </Grid.Column>
            <Grid.Column>
              <div
                style={{
                  display: "flex"
                }}
              >
                <div>
                  <Image
                    src={vestidorIcon}
                    style={{
                      height: "38px",
                      width: "38px",
                      verticalAlign: "top"
                    }}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginLeft: "10px"
                  }}
                >
                  <div>
                    <Header
                      style={{
                        color: "#fff",
                        padding: "0px",
                        margin: "0px",
                        fontSize: "1.2rem"
                      }}
                    >
                      {this.props.specsData.dressrooms}
                    </Header>
                  </div>
                  <div>
                    <p
                      style={{
                        fontFamily: "Lato",
                        fontWeight: 300,
                        color: "#fff",
                        fontSize: "0.7rem"
                      }}
                    >
                      VESTIDOR:
                    </p>
                  </div>
                </div>
              </div>
            </Grid.Column>
          </Grid>
        </div>
      </div>
    );
  }
  renderInMobile() {
    let constructArea = "";
    if (this.props.specsData.constructArea !== undefined) {
      constructArea =
        this.props.specsData.constructArea.width +
        " m²" +
        " - " +
        this.props.specsData.constructArea.height +
        " m²";
    }
    return (
      <div>
        <div
          style={{
            backgroundColor: "#023552",
            width: "100%",
            padding: "25px"
          }}
        >
          <Grid columns={1}>
            <Grid.Column>
              <div
                style={{
                  display: "flex"
                }}
              >
                <div>
                  <Image
                    src={precioIcon}
                    style={{
                      height: "38px",
                      width: "38px"
                    }}
                  />
                </div>
                <div
                  style={{
                    marginLeft: "10px"
                  }}
                >
                  <Header
                    style={{
                      color: "#fff",
                      padding: "0px",
                      margin: "0px",
                      fontSize: "1.2rem"
                    }}
                  >
                    {formatter.format(this.props.specsData.minPrice).toString()}{" "}
                    -{" "}
                    {formatter.format(this.props.specsData.maxPrice).toString()}
                  </Header>
                  <p
                    style={{
                      fontSize: "0.7rem",
                      fontFamily: "Lato",
                      fontWeight: 300,
                      color: "#fff"
                    }}
                  >
                    PRECIO DESDE:
                  </p>
                </div>
              </div>
            </Grid.Column>

            <Grid.Column textAlign="left">
              <div
                style={{
                  display: "flex"
                }}
              >
                <div>
                  <Image
                    src={construccionIcon}
                    style={{
                      height: "38px",
                      width: "38px"
                    }}
                  />
                </div>
                <div
                  style={{
                    marginLeft: "10px"
                  }}
                >
                  <Header
                    style={{
                      color: "#fff",
                      padding: "0px",
                      margin: "0px",
                      fontSize: "1.2rem"
                    }}
                  >
                    {constructArea}
                  </Header>
                  <p
                    style={{
                      fontFamily: "Lato",
                      fontWeight: 300,
                      color: "#fff",
                      fontSize: "0.7rem"
                    }}
                  >
                    ÁREA DE CONSTRUCCIÓN:
                  </p>
                </div>
              </div>
            </Grid.Column>
          </Grid>

          <Grid columns={1}>
            <Grid.Column>
              <Grid>
                <Grid.Column>
                  <div
                    style={{
                      display: "flex"
                    }}
                  >
                    <div>
                      <Image
                        src={recamarasIcon}
                        style={{
                          height: "38px",
                          width: "38px",
                          verticalAlign: "top"
                        }}
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginLeft: "10px"
                      }}
                    >
                      <div>
                        <Header
                          style={{
                            color: "#fff",
                            padding: "0px",
                            margin: "0px",
                            fontSize: "1.2rem"
                          }}
                        >
                          {this.props.specsData.rooms}
                        </Header>
                      </div>

                      <div>
                        <p
                          style={{
                            fontFamily: "Lato",
                            fontWeight: 300,
                            color: "#fff",
                            fontSize: "0.7rem"
                          }}
                        >
                          RECÁMARAS:
                        </p>
                      </div>
                    </div>
                  </div>
                </Grid.Column>
              </Grid>
            </Grid.Column>
            <Grid.Column>
              <div
                style={{
                  display: "flex"
                }}
              >
                <div>
                  <Image
                    src={banoIcon}
                    style={{
                      height: "38px",
                      width: "38px",
                      verticalAlign: "top"
                    }}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginLeft: "10px"
                  }}
                >
                  <div>
                    <Header
                      style={{
                        color: "#fff",
                        padding: "0px",
                        margin: "0px",
                        fontSize: "1.2rem"
                      }}
                    >
                      {this.props.specsData.bathrooms}
                    </Header>
                  </div>

                  <div>
                    <p
                      style={{
                        fontFamily: "Lato",
                        fontWeight: 300,
                        color: "#fff",
                        fontSize: "0.7rem"
                      }}
                    >
                      BAÑOS:
                    </p>
                  </div>
                </div>
              </div>
            </Grid.Column>
            <Grid.Column>
              <div
                style={{
                  display: "flex"
                }}
              >
                <div>
                  <Image
                    src={estacionamientoIcon}
                    style={{
                      height: "38px",
                      width: "38px",
                      verticalAlign: "top"
                    }}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginLeft: "10px"
                  }}
                >
                  <div>
                    <Header
                      style={{
                        color: "#fff",
                        padding: "0px",
                        margin: "0px",
                        fontSize: "1.2rem"
                      }}
                    >
                      {this.props.specsData.parkinglots}
                    </Header>
                  </div>

                  <div>
                    <p
                      style={{
                        fontFamily: "Lato",
                        fontWeight: 300,
                        color: "#fff",
                        fontSize: "0.7rem"
                      }}
                    >
                      ESTACIONAMIENTO:
                    </p>
                  </div>
                </div>
              </div>
            </Grid.Column>
            <Grid.Column>
              <div
                style={{
                  display: "flex"
                }}
              >
                <div>
                  <Image
                    src={vestidorIcon}
                    style={{
                      height: "38px",
                      width: "38px",
                      verticalAlign: "top"
                    }}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginLeft: "10px"
                  }}
                >
                  <div>
                    <Header
                      style={{
                        color: "#fff",
                        padding: "0px",
                        margin: "0px",
                        fontSize: "1.2rem"
                      }}
                    >
                      {this.props.specsData.dressrooms}
                    </Header>
                  </div>
                  <div>
                    <p
                      style={{
                        fontFamily: "Lato",
                        fontWeight: 300,
                        color: "#fff",
                        fontSize: "0.7rem"
                      }}
                    >
                      VESTIDOR:
                    </p>
                  </div>
                </div>
              </div>
            </Grid.Column>
          </Grid>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        <Responsive {...Responsive.onlyMobile}>
          {this.renderInMobile()}
        </Responsive>
        <Responsive {...Responsive.onlyTablet}>
          {this.renderInTablet()}
        </Responsive>
        <Responsive {...Responsive.onlyComputer}>
          {this.renderInDesktop()}
        </Responsive>
      </div>
    );
  }
}

export default PropiedadesPage;
